'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEmpty3 = require('lodash/isEmpty');

var _isEmpty4 = _interopRequireDefault(_isEmpty3);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./FineUploader.scss');
var desktopImg = require('assets/desktop-icon.png');

var UploadArea = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(UploadArea, _Component);

  function UploadArea() {
    (0, _classCallCheck3.default)(this, UploadArea);
    return (0, _possibleConstructorReturn3.default)(this, (UploadArea.__proto__ || (0, _getPrototypeOf2.default)(UploadArea)).apply(this, arguments));
  }

  (0, _createClass3.default)(UploadArea, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          uploader = _props.uploader,
          t = _props.t,
          submittedFiles = _props.submittedFiles,
          children = _props.children,
          accept = _props.accept,
          multiple = _props.multiple,
          onDropError = _props.onDropError,
          hideHeader = _props.hideHeader,
          clickable = _props.clickable,
          showStatusIcon = _props.showStatusIcon,
          _onDelete = _props.onDelete,
          _onCancel = _props.onCancel,
          submittedCloudFiles = _props.submittedCloudFiles,
          uploadButtons = _props.uploadButtons,
          disabled = _props.disabled;

      var isMediaFiles = !(0, _isEmpty4.default)(submittedFiles);
      var isCloudFiles = !(0, _isEmpty4.default)(submittedCloudFiles);
      var isDisplayedCloudFiles = !!(submittedCloudFiles && submittedCloudFiles.filter(function (file) {
        return file.status !== 'success';
      }).length);

      return _react2.default.createElement(
        _components.DropZone,
        {
          clickable: clickable,
          multiple: multiple,
          uploader: uploader,
          onDropError: onDropError,
          disabled: disabled,
          className: (0, _classnames2.default)({ disabled: disabled })
        },
        clickable ? _react2.default.createElement(
          _components.FileInput,
          { className: styles.clickableArea, multiple: multiple, accept: accept, uploader: uploader, disabled: disabled },
          _react2.default.createElement(
            'div',
            { className: 'overflow-hidden' },
            !hideHeader && _react2.default.createElement(
              'span',
              null,
              t('Drop Files Here')
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            children
          )
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'overflow-hidden' },
            !hideHeader && _react2.default.createElement(
              'span',
              null,
              t('Drop Files Here')
            ),
            _react2.default.createElement(
              'div',
              { className: styles.uploadButtons },
              _react2.default.createElement(
                _components.FileInput,
                { className: styles.computerButton, uploader: uploader, accept: accept, multiple: true, disabled: disabled },
                _react2.default.createElement(
                  'span',
                  { className: (0, _classnames2.default)('btn btn-clear', (0, _defineProperty3.default)({}, styles.disabledButton, disabled)) },
                  _react2.default.createElement(
                    _components.Tooltip,
                    { placement: 'bottom', title: t('Upload from computer') },
                    _react2.default.createElement('img', { src: desktopImg, alt: '' })
                  )
                )
              ),
              uploadButtons
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            children
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('margin-top-10', { 'padding-10': clickable }) },
          isMediaFiles && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'hint small' },
              t('Files from the computer')
            ),
            submittedFiles.map(function (id) {
              return _react2.default.createElement(_components.UploaderItem, {
                className: 'margin-bottom-10',
                key: id,
                id: id,
                uploader: uploader,
                showStatusIcon: showStatusIcon,
                onDelete: function onDelete() {
                  return _onDelete(id);
                },
                onCancel: function onCancel() {
                  return _onCancel(id);
                },
                cancelable: true
              });
            })
          ),
          isCloudFiles && _react2.default.createElement(
            'div',
            null,
            isDisplayedCloudFiles && _react2.default.createElement(
              'div',
              { className: 'hint small' },
              t('Files from the cloud services')
            ),
            submittedCloudFiles.map(function (cloudFile) {
              return _react2.default.createElement(_components.CloudUploaderItem, {
                key: cloudFile.uniqId,
                showOnSuccess: false,
                deletable: true,
                onDelete: function onDelete() {
                  return _this2.deleteCloudItem(cloudFile);
                },
                cloudFile: cloudFile
              });
            })
          ),
          isMediaFiles && _react2.default.createElement(_components.TotalProgress, { uploader: uploader })
        )
      );
    }
  }]);
  return UploadArea;
}(_react.Component), _class2.propTypes = {
  accept: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  clickable: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  hideHeader: _propTypes2.default.bool,
  multiple: _propTypes2.default.bool,
  onCancel: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onDropError: _propTypes2.default.func,
  showStatusIcon: _propTypes2.default.bool,
  submittedCloudFiles: _propTypes2.default.array,
  submittedFiles: _propTypes2.default.array,
  t: _propTypes2.default.func,
  uploadButtons: _propTypes2.default.node,
  uploader: _propTypes2.default.object
}, _class2.defaultProps = {
  multiple: true
}, _temp)) || _class);
exports.default = UploadArea;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/UploadArea.js
// module id = 2002
// module chunks = 1